module.exports = require('./dist/react-data-grid');


//////////////////
// WEBPACK FOOTER
// ./~/react-data-grid/index.js
// module id = 29
// module chunks = 6